
import { createContext } from "react";
import { CognitoOTPAuthContextType } from "./CognitoOTPTypes";

const CognitoOTPAuthContextInitialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  session: null
};

const CognitoOTPAuthContext = createContext<CognitoOTPAuthContextType>({
  ...CognitoOTPAuthContextInitialState,
  method: 'cognito',
  initiateLogin: (_userName: string) => Promise.resolve(),
  login: (_otp: string) => Promise.resolve(),
  logout: (_revokeToken: boolean) => Promise.resolve()
});

export { CognitoOTPAuthContextInitialState, CognitoOTPAuthContext }